import { error } from 'util';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Router, NavigationEnd } from '@angular/router';
import { EventsService } from 'angular4-events';
// import {PubSubService} from 'angular2-pubsub';


declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {
  nao = new Nanobar();
  storeData: any;
  shortName: any;
  cityName: any;
  lowerRange: any;
  upperRange: any;
  country: any;
  countryEdit: any;
  storeDataEdit: any;
  shortNameEdit: any;
  cityNameEdit: any;
  lowerRangeEdit: any;
  upperRangeEdit: any;
  cityImage: any;
  cityImageEdit = null;
  error_count: any;
  addCitySuccess: any;
  btnDisabled = false;
  btnDisabledEdit = false;
  cityNameConfirm: any;
  removeSuccess: any;
  removeSuccessMsg: any;
  cityRemoveId: any;
  DetailData: any;
  cityIdToSendForEdit: any;
  editimgChk: any;
  isNationWide = false;
  message: any;
  disableClick: any;
  seoTitle = '';
  seoDescription = '';
  seoKeywords = '';
  disableSeoField = true;
  seoDetail: any;
  seoData: any;
  seo_title: any;
  seo_description: any;
  seo_keyword: any;
  localDeliveryCharges: any = {}
  constructor(private dataService: DataService, private router: Router) {
    this.dataService.pageName = 'story';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }
  addCityPopOpen() {
    this.shortName = '';
    this.cityName = '';
    this.lowerRange = '';
    this.upperRange = '';
    this.country = '';
    this.cityImage = '';
    this.cityImage = undefined;
    this.seoTitle = '';
    this.seoDescription = '';
    this.seoKeywords = '';
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadText').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    $('.c-label label').css('color', '#3d3e3d');
    $('#addCityPop').modal('show');
  }
  storeListFunction() {
    this.nao.go(30);
    this.dataService.getStoreList(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        this.storeData = [];
        this.storeData = data;
        this.storeData = this.storeData.city_list;
        // console.log('storeData', this.storeData);
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  islocal() {
    if ($('#nationWide').prop('checked') === true) {
      this.isNationWide = true;
    } else {
      this.isNationWide = false;
    }
  }
  convertHTMLtoText(html) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
  addCity() {
    this.error_count = 0;
    $('.note-editor.note-frame').css('border-color', '#a9a9a9');
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadText').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    // this.cityImage = $('#image-cropper').cropit('export');
    if (this.cityImage === undefined) {
      $('.uploadText').css('color', '#a10a0d');
      this.error_count++;
    }
    if (this.shortName === '' || this.shortName === undefined) {
      $('#short-name label').css('color', '#a10a0d');
      $('#short-name input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.cityName === '' || this.cityName === undefined) {
      $('#city-name label').css('color', '#a10a0d');
      $('#city-name input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.isNationWide === true) {
      this.lowerRange = null;
      this.upperRange = null;
    } else {
      if (this.lowerRange === '' || this.lowerRange === undefined) {
        $('#upper-name label').css('color', '#a10a0d');
        $('#upper-name input').css('border-color', '#a10a0d');
        this.error_count++;
      }
      // if (this.upperRange === '' || this.upperRange === undefined) {
      //     $('#upper-name label').css('color', '#a10a0d');
      //     $('#upper-name input').css('border-color', '#a10a0d');
      //     this.error_count ++;
      // }
    }
    if (this.country === '' || this.country === undefined) {
      $('#cn-name label').css('color', '#a10a0d');
      $('#cn-name input').css('border-color', '#a10a0d');
      this.error_count++;
    }

    if ($('#summernote').summernote('isEmpty')) {
      $('.note-editor.note-frame').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.seoTitle === '' || this.seoTitle === undefined) {
      $('#seoTitle label').css('color', '#a10a0d');
      $('#seoTitle textarea').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.seoDescription === '' || this.seoDescription === undefined) {
      $('#seoDescription label').css('color', '#a10a0d');
      $('#seoDescription textarea').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.seoKeywords === '' || this.seoKeywords === undefined) {
      $('#seoKeywords label').css('color', '#a10a0d');
      $('#seoKeywords textarea').css('border-color', '#a10a0d');
      this.error_count++;
    }

    if (this.error_count > 0) {
      this.btnDisabled = false;
      return;
    }
    this.btnDisabled = true;
    if (this.isNationWide === false) {
      this.lowerRange = this.lowerRange.trim();
    }



    var html = $('#summernote').summernote('code');
    var htmlValue = this.convertHTMLtoText(html);
    // console.log('htmlValuehtmlValue', htmlValue);
    if (htmlValue === '') {
      html = '';
    }
    this.nao.go(30);
    this.dataService.uploadCity(window.localStorage.getItem('token'), this.shortName, this.cityName, this.country, this.lowerRange, this.cityImage, this.isNationWide, html, this.seoTitle, this.seoDescription, this.seoKeywords).subscribe(
      (data) => {
        this.nao.go(100);
        this.btnDisabled = false;
        this.addCitySuccess = data;
        this.message = data;
        this.message = this.message.message;
        this.addCitySuccess = this.addCitySuccess.success;
        this.btnDisabled = false;
        if (this.addCitySuccess === true) {
          this.storeListFunction();
          $('#addCityPop').modal('hide');
        } else {
          toastr.error(this.message);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  cityRemovePop(id, name) {
    this.cityRemoveId = id;
    this.cityNameConfirm = name;
    $('#cityRemovePop').modal('show');
  }
  removeCityFunction(id) {
    this.disableClick = true;
    this.nao.go(30);
    this.dataService.deleteCity(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.removeSuccess = data;
        if (this.removeSuccess.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.removeSuccess.rest_error_code === 2) toastr.error('Please login again');
        if (this.removeSuccess.rest_error_code === 4) toastr.error('Doest not exist');
        this.removeSuccessMsg = this.removeSuccess.message;
        this.removeSuccess = this.removeSuccess.success;
        if (this.removeSuccess === true) {
          this.storeListFunction();
          $('#cityRemovePop').modal('hide');
          // toastr.error(this.removeSuccessMsg);
          // this.driverlist();
        } else {
          // toastr.error(this.removeSuccessMsg);
        }
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        this.disableClick = false;
      }
    );
  }
  detailEditfunction(id) {
    $('.note-editor.note-frame').css('border-color', '#a9a9a9');
    $('.c-label textarea').css('border-color', '#ccc');
    $('.c-label label').css('color', '#3d3e3d');
    this.nao.go(30);
    this.cityIdToSendForEdit = id;
    this.dataService.cityDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.DetailData = data;
        this.shortNameEdit = this.DetailData.city_short_name;
        this.cityNameEdit = this.DetailData.city;
        this.lowerRangeEdit = this.DetailData.lower_range;
        // this.upperRangeEdit = this.DetailData.upper_range;
        this.countryEdit = this.DetailData.country;
        this.cityImageEdit = this.DetailData.image;
        this.editimgChk = this.DetailData.image;
        // this.cityImageEdit = this.DetailData.image;
        $('#summernoteEdit').summernote('code', this.DetailData.html_description);

        this.seoTitle = this.DetailData.seo_title;
        this.seoDescription = this.DetailData.seo_description;
        this.seoKeywords = this.DetailData.seo_keyword;

        $('#editCityPop').modal('show');
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  editCity() {
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadText').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    // this.cityImageEdit = $('#image-cropper2').cropit('export');

    if (this.shortNameEdit === '' || this.shortNameEdit === undefined) {
      $('#short-nameEdit label').css('color', '#a10a0d');
      $('#short-nameEdit input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.cityNameEdit === '' || this.cityNameEdit === undefined) {
      $('#city-nameEdit label').css('color', '#a10a0d');
      $('#city-nameEdit input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.lowerRangeEdit === '' || this.lowerRangeEdit === undefined) {
      $('#cn-nameEdit label').css('color', '#a10a0d');
      $('#cn-nameEdit input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    // if (this.upperRangeEdit === '' || this.upperRangeEdit === undefined) {
    //     $('#upper-nameEdit label').css('color', '#a10a0d');
    //     $('#upper-nameEdit input').css('border-color', '#a10a0d');
    //     this.error_count ++;
    // }
    if (this.countryEdit === '' || this.countryEdit === undefined) {
      $('#lower-nameEdit label').css('color', '#a10a0d');
      $('#lower-nameEdit input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    var cityImg = this.cityImageEdit;
    if (this.cityImageEdit === this.editimgChk) {
      cityImg = undefined;
      // this.error_count ++;
    }
    if ($('#summernoteEdit').summernote('isEmpty')) {
      $('.note-editor.note-frame').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.seoTitle === '' || this.cityNameEdit === undefined) {
      $('#seoTitleEdit label').css('color', '#a10a0d');
      $('#seoTitleEdit textarea').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.seoDescription === '' || this.cityNameEdit === undefined) {
      $('#seoDescriptionEdit label').css('color', '#a10a0d');
      $('#seoDescriptionEdit textarea').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.seoKeywords === '' || this.cityNameEdit === undefined) {
      $('#seoKeywordsEdit label').css('color', '#a10a0d');
      $('#seoKeywordsEdit textarea').css('border-color', '#a10a0d');
      this.error_count++;
    }

    if (this.error_count > 0) {
      this.btnDisabledEdit = false;
      return;
    }
    this.btnDisabledEdit = true;
    this.lowerRangeEdit = this.lowerRangeEdit.trim();
    var html = $('#summernoteEdit').summernote('code');
    var htmlValue = this.convertHTMLtoText(html);
    console.log('htmlValuehtmlValue', htmlValue);
    if (htmlValue === '') {
      html = '';
    }
    this.nao.go(30);
    this.dataService.editCityData(window.localStorage.getItem('token'), this.cityIdToSendForEdit, this.shortNameEdit, this.cityNameEdit, this.countryEdit, this.lowerRangeEdit, cityImg, html, this.seoTitle, this.seoDescription, this.seoKeywords).subscribe(
      (data) => {
        this.nao.go(100);
        this.btnDisabledEdit = false;
        this.addCitySuccess = data;
        this.addCitySuccess = this.addCitySuccess.success;
        this.btnDisabled = false;
        if (this.addCitySuccess === true) {
          this.storeListFunction();
          $('#editCityPop').modal('hide');
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  clearTileImage() {
    $('.cropit-image-input-tile').val('');
  }
  expotyTile() {
    $('.cropit-image-input-tile').val('');
    this.cityImage = $('.image-cropper-tile').cropit('export', {
      originalSize: true,
      quality: 1,
      type: 'image/png',
    });
    $('#cropperTileImgPop').modal('hide');
  }
  clearLogoImage() {
    $('.cropit-image-input2').val('');
  }
  expotyProfile() {
    $('.cropit-image-input2').val('');
    this.cityImageEdit = $('.image-cropper2').cropit('export', {
      originalSize: true,
      quality: 1,
      type: 'image/png',
    });
    // console.log('banner export', this.dispensarySquareImage);
    $('#cropperProfileImgPop').modal('hide');
  }
  callsummerFun() {
    $('#summernote, #summernoteEdit').summernote({
      placeholder: 'City Description here',
      tabsize: 2,
      height: 300,
      minHeight: 300,
    });
  }
  ngOnInit() {
    this.callsummerFun();
    this.storeListFunction();
    this.getHomeSeo();

    $('#cropperTileImgPop').on('hidden.bs.modal', function () {
      $('body').addClass('modal-open');
    });


    // $('.select-image-btn').click(function() {
    //   $('.cropit-image-input').click();
    // });
    // $('#image-cropper').cropit({
    //     $preview: $('.cropit-preview'),
    //     allowDragNDrop: true,
    // });
    //    $('#image-cropper2').cropit({
    //         $preview: $('.cropit-preview2'),
    //         $fileInput: $('.cropit-image-input2'),
    //         allowDragNDrop: true,
    //         // minZoom: 'fit',
    //         // maxZoom: 20,
    //         // imageBackground: false,
    //         // imageBackgroundBorderWidth: 30
    // });
    // $('.select-image-btn2').click(function() {
    //   $('.cropit-image-input2').click();
    // });
    setTimeout(() => {
      $('.image-cropper-tile').cropit({
        $preview: $('.cropit-preview-tile'),
        $fileInput: $('.cropit-image-input-tile'),
        $zoomSlider: $('.cropit-image-zoom-input-tile'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
      });
    }, 1500);
    $('#cropit-image-input-tile').change(function () {
      console.log('in image preview2');
      console.log('', $('.cropit-image-input-tile').val());
      if ($('.cropit-image-input-tile').val() !== '') {
        $('#cropperTileImgPop').modal('show');
      }
    });
    $('.select-image-btn-tile').click(function () {
      $('#cropit-image-input-tile').click();
    });
    setTimeout(() => {
      $('.image-cropper2').cropit({
        $preview: $('.cropit-preview2'),
        $fileInput: $('.cropit-image-input2'),
        $zoomSlider: $('.cropit-image-zoom-input-logo'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
      });
    }, 1500);
    $('#cropit-image-input2').change(function () {
      console.log('in image preview2');
      console.log('', $('.cropit-image-input2').val());
      if ($('.cropit-image-input2').val() !== '') {
        $('#cropperProfileImgPop').modal('show');
      }
    });
    $('.select-image-btn2').click(function () {
      $('#cropit-image-input2').click();
    });
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#store').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

  getHomeSeo() {
    this.dataService.getSeoHomeDetail(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.seoDetail = data;
        console.log('this.seoDetail', this.seoDetail);
        this.seo_title = this.seoDetail.seo_title;
        this.seo_description = this.seoDetail.seo_description;
        this.seo_keyword = this.seoDetail.seo_keyword;
      },
      (error) => {
        console.log('error', error);
      }
    );

  }

  editHomeSeo() {
    this.dataService.getSeoHomeEdit(window.localStorage.getItem('token'), this.seo_title, this.seo_description, this.seo_keyword).subscribe(
      (data) => {
        this.seoData = data;
        console.log('this.seoData', this.seoData);
        this.seo_title = this.seoData.seo_title;
        this.seo_description = this.seoData.seo_description;
        this.seo_keyword = this.seoData.seo_keyword;
        this.disableSeoField = true;
        this.getHomeSeo();
      },
      (error) => {
        console.log('error', error);
      }
    );

  }

  editSeo() {
    this.disableSeoField = false;
  }

  cancelSeo() {
    this.disableSeoField = true;
  }


  changeFirstZoneDistance(distance) {
    this.localDeliveryCharges.firstzone_distance = distance
  }
  
  changeNextZoneDistance(distance) {
    this.localDeliveryCharges.lastzone_distance = distance
  }

  openDeliveryChargesPopUp(city_id) {
    this.nao.go(30);
    this.localDeliveryCharges.city_id = city_id;
    let auth_token: string = localStorage.getItem('token');
    this.dataService.getCityDeliveryCharges({ city_id, auth_token })
      .subscribe((res: any) => {
        if (!res.rest_error_code) {
          this.nao.go(100);
          this.localDeliveryCharges.first_zone = res.first_zone_distance;
          this.localDeliveryCharges.firstzone_distance = res.first_zone_distance_string;
          this.localDeliveryCharges.last_zone = res.next_zone_distance;
          this.localDeliveryCharges.lastzone_distance = res.next_zone_distance_string;
          this.localDeliveryCharges.firstzone_charges = res.first_zone_charges;
          this.localDeliveryCharges.lastzone_charges = res.next_zone_charges;
          this.localDeliveryCharges.fuel_price = res.fuel_price;
          this.localDeliveryCharges.driver_percentage = res.driver_percentage;
          this.localDeliveryCharges.city_id = res.id;
        } else {
          toastr.error('Something went wrong 1 ');
          this.localDeliveryCharges = {};
          this.localDeliveryCharges.firstzone_distance = 'Miles';
          this.localDeliveryCharges.lastzone_distance = 'Miles';
          this.localDeliveryCharges.auth_token = auth_token;
          this.localDeliveryCharges.city_id = city_id;
          this.localDeliveryCharges.fuel_price = 0;
          // $('#deliveryFeePopup').modal('hide');
        }
      },
        (error) => {
          toastr.error('Something went wrong 2');
          this.localDeliveryCharges = {};
          this.localDeliveryCharges.firstzone_distance = 'Miles';
          this.localDeliveryCharges.lastzone_distance = 'Miles';
          this.localDeliveryCharges.auth_token = auth_token;
          this.localDeliveryCharges.city_id = city_id;
          this.localDeliveryCharges.fuel_price = 0;
          $('#deliveryFeePopup').modal('hide');
        });

    $('#deliveryFeePopup').modal('show');
    this.nao.go(100)
  }

  updateLocalDeliveryFee() {
    let auth_token: string = localStorage.getItem('token');

    if(!this.localDeliveryCharges ){
      toastr.error('Something went wrong');
    }else{
    this.nao.go(30);
    this.dataService.updateLocalDeliveryCharges({...this.localDeliveryCharges, auth_token})
      .subscribe(
        (res: any) => {
          this.nao.go(100)
          if (res.success) {
            $('#deliveryFeePopup').modal('hide');
          } else {
            toastr.error('Something went wrong');
          }

        }, (error) => {
          this.nao.go(100)
          console.log("error", error);
        })
    }

    
  }
}



// WEBPACK FOOTER //
// ./src/app/store/store.component.ts